import PATH from 'crono-fe-common/constants/path';

//module routes
import { Outlet, RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import connectRoutes from 'pages/connect/routes';
import CompanyInterceptor from './companyInterceptor';
import ContactInterceptor from './contactInterceptor';
import CallInterceptor from './callInterceptor';
import TaskInterceptor from './taskInterceptor';
import SubscriptionPageInterceptor from './subscriptionPageInterceptor';
import SuccessSignupInterceptor from './successSignUpInterceptor';
import { useAuth } from 'context/auth';
import OpportunityInterceptor from './opportunityInterceptor';
import ListInterceptor from './listInterceptor';
import { LIST_DETAIL_PATH } from './listInterceptor/paths';

const HomePage = lazy(() => import('pages/home'));

const MfaRoute = ({ element }: { element: React.ReactNode }) => {
  const { user } = useAuth();
  return user ? <HomePage /> : <>{element}</>;
};
const LoginPage = lazy(() => import('pages/login'));
const OnboardingPage = lazy(() => import('pages/onboarding'));
const MigrationPage = lazy(() => import('pages/migration'));
const SubscriptionPage = lazy(() => import('pages/subscription'));
const ExpiredPlan = lazy(() => import('pages/subscriptionPlans/expired'));
const SignUpPage = lazy(() => import('pages/signup'));
const ThankYouPage = lazy(() => import('pages/thankYou'));
const ResetPasswordPage = lazy(() => import('pages/resetPassword'));
const ForgotPasswordPage = lazy(() => import('pages/forgotPassword'));
const RegisterPage = lazy(() => import('pages/register'));
const OptOutPage = lazy(() => import('pages/optOutPage'));
const MfaPage = lazy(() => import('pages/mfa'));
const MfaSetupPage = lazy(() => import('pages/mfa-setup'));
const OAuthConsentPage = lazy(() => import('pages/oauthConsent'));
const SlackWorkspaceOauthCallback = lazy(
  () => import('pages/oauth/slack/SlackWorkspaceOauthCallback'),
);
const SlackUserOauthCallback = lazy(
  () => import('pages/oauth/slack/SlackUserOauthCallback'),
);

export const Routes: RouteObject[] = [
  {
    path: PATH.FREE_TRIAL,
    element: <RegisterPage freeTrial={true} />,
  },
  {
    path: PATH.REGISTER,
    element: <RegisterPage freeTrial={false} />,
  },
  {
    path: PATH.CONNECT,
    element: <Outlet />,
    children: connectRoutes,
  },
  {
    path: PATH.THANK_YOU,
    element: <ThankYouPage />,
  },
  {
    path: PATH.SUCCESS_SIGN_UP,
    element: <SuccessSignupInterceptor />,
  },
  {
    path: PATH.SIGN_UP,
    element: <SignUpPage />,
  },
  {
    path: PATH.EXPIRED,
    element: <ExpiredPlan />,
  },
  {
    path: PATH.COMPLETE,
    element: <SubscriptionPage />,
  },
  {
    path: PATH.ONBOARDING,
    element: <OnboardingPage />,
  },
  {
    path: PATH.MIGRATION,
    element: <MigrationPage />,
  },
  {
    path: PATH.LOGIN,
    element: <LoginPage />,
  },
  {
    path: PATH.FORGOT_PASSWORD,
    element: <ForgotPasswordPage />,
  },
  {
    path: PATH.RESET_PASSWORD,
    element: <ResetPasswordPage />,
  },
  {
    path: PATH.CREATE_PASSWORD,
    element: <ResetPasswordPage createPasswordView={true} />,
  },
  {
    path: PATH.MFA,
    element: <MfaRoute element={<MfaPage />} />,
  },
  {
    path: PATH.MFA_SETUP,
    element: <MfaRoute element={<MfaSetupPage />} />,
  },
  {
    path: PATH.COMPANY,
    element: <CompanyInterceptor />,
  },
  {
    path: PATH.CONTACT,
    element: <ContactInterceptor />,
  },
  {
    path: PATH.DEALS_DETAIL,
    element: <OpportunityInterceptor />,
  },
  {
    path: LIST_DETAIL_PATH,
    element: <ListInterceptor />,
  },
  {
    path: PATH.CALL,
    element: <CallInterceptor />,
  },
  {
    path: PATH.TASK,
    element: <TaskInterceptor />,
  },
  {
    path: PATH.SUBSCRIPTION_PAGE,
    element: <SubscriptionPageInterceptor />,
  },
  { path: PATH.OAUTH_CONSENT, element: <OAuthConsentPage /> },
  { path: PATH.OAUTH_SLACK, element: <SlackWorkspaceOauthCallback /> },
  { path: PATH.OAUTH_SLACK_USER, element: <SlackUserOauthCallback /> },
  {
    path: PATH.OPT_OUT,
    element: <OptOutPage />,
  },
  {
    path: '/*',
    element: <HomePage />,
  },
];
